const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development';
const baseUrl = environment === 'production' ? process.env.REACT_APP_API_URL :process.env.REACT_APP_API_URL;
export const baseURL = baseUrl;